import { IChoiceOption } from '../../models/Choice'
import Conditional from '../common/Conditional'
import { isURL } from '../../utilities/commonFunctions'

export interface IGetHelpOptionProps {
  value?: number
  option: IChoiceOption
  radioHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const GetHelpOption = (props: IGetHelpOptionProps) => {
  return (
    <div>
      <label
        className={
          props.value === props.option.id
            ? 'selected button is-primary'
            : 'button'
        }
        htmlFor={`rd-${props.option.id}`}
      >
        <input
          type="radio"
          name="rdChoicesGroup"
          id={`rd-${props.option.id}`}
          value={props.option.id}
          checked={props.value && props.option.id === props.value}
          onChange={props.radioHandler}
        />
        {props.option.choiceHeader}
        <Conditional
          if={props.option.url?.length > 0 && isURL(props.option.url)}
        >
          &nbsp;&nbsp;
          <a
            href={props.option.url}
            target="_blank"
            rel="noreferrer"
            className="external-link"
          ></a>
        </Conditional>
      </label>
    </div>
  )
}

export default GetHelpOption
